import Page from './LessonSearchPage';

// eslint-disable-next-line import/export -- auto-generated TECH-258
export * from './LessonSearchPage';
export default Page;
